import React from 'react';
import * as cls from './what-it-means-to-you.module.css';

import { IMG_PATH } from '../../../constants';
import { Section } from '../../../ui/components/section';
import { Typography } from '../../../ui/components/typography';

const items = [
  {
    text: (
      <>
        <em>10× more digital engagement –</em> Voltaware users log in 17 times
        per month vs. {'<2'} for most utility apps.
      </>
    ),
  },
  {
    text: (
      <>
        <em>Cut call-centre costs by 30%+ –</em> UK pilots showed 32% fewer
        high-bill complaints.
      </>
    ),
  },
  {
    text: (
      <>
        <em>+2 years customer retention –</em> sustained engagement increases
        lifetime value.
      </>
    ),
  },
  {
    text: (
      <>
        <em>New value-added services in 1 year –</em> appliance insights create
        upsell paths for EVs, heat pumps, solar, batteries, and efficiency kits.
      </>
    ),
  },
];

export const WhatItMeansToYou = () => {
  return (
    <Section backgroundContrast>
      <Typography tag="h2">What it Means to You</Typography>
      <ul className={cls.list}>
        {items.map((item, index) => (
          <li key={index}>
            <img
              alt=""
              src={`${IMG_PATH}/utilities/ico-what-it-means-to-you-${index + 1}.svg`}
            />
            <Typography>{item.text}</Typography>
          </li>
        ))}
      </ul>
    </Section>
  );
};
